import { menuAnimation } from '../animations/menu.js';
import visible from '../util/visible';
import $ from 'jquery';
import 'tilt.js';
import Aos from 'aos';

// Change the logo colour if there is a class requesting it
export const ChangeLogoColour = function () {
  if ($(window).width() >= 771 && $(window).height() > 650) {
    if (visible('.make-header-light')) {
      if ($('.make-header-light').is(':visible')) {
        $('header').addClass('is-light');
      }
    } else {
      $('header').removeClass('is-light');
    }
  }
};

// Toggle the menu
export const toggleMenu = function () {
  menuAnimation();
};

export default {
  init() {
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.toggle-menu').click(function () {
      toggleMenu();
    });

    $('input[type=checkbox]').click(function () {
      $(this).toggleClass('is-checked');
    });

    // menu animation on hover
    $('nav li').hover(function () {
      var item = $(this).find('.menu-title').data('item');
      item = '.menu-item-image.' + item;
      $('.menu-item-image').removeClass('has-hover-state');
      $(item).addClass('has-hover-state');
    });

    $('.tilt').tilt({
      glare: true,
      maxGlare: .5,
      maxTilt: 4,
      speed: 500,
    });

    setTimeout(function () {
      Aos.init();
      let blurredElements = $('.blur-in');

      for (let i = 0; i < blurredElements.length; i++) {

        // let delay = $(this).prop('blur-delay');
      }

      $('.blur-in').addClass('active');
    }, 2000)

    // rotate device
    function checkOrientation() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        if (window.matchMedia('(orientation: portrait)').matches) {
          $('body').removeClass('landscape');
        }
        if (window.matchMedia('(orientation: landscape)').matches) {
          $('body').addClass('landscape');
        }
      }
    }
    $(window).on('resize', function () {
      checkOrientation();
    });
    checkOrientation();

    // locations
    $('.location_1').addClass('is-active');
    $('.location-title').on('click touchend', function () {
      var clicked = $(this).data('location');
      $('.location-title').removeClass('is-active');
      $('.location').removeClass('is-active');


      $(this).addClass('is-active');
      $('.location.' + clicked).addClass('is-active');
    });
  },
};
